<template>
  <div class="msg-bell-msg-view">
    <div v-show="addDialog.view === 'list'" class="main-content">
      <div class="app-main-inner-row" style="padding-top: 10px;">
        <div class="triggers">
          <span>{{ $t('CargoMsg.Cargo_ScenarioName') }}</span>
          <el-input
            v-model="pageInfo.jobNo"
            :placeholder="$t('SeaExport.PleaseInputAKeyword')"
            style="width:200px;margin: 0 10px"
            @input="searchHandle()"
          />
          <el-button type="primary" @click="searchHandle">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" @click="btnAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="btnCopy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
          <el-button type="danger" @click="btnRemoveHandler">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper" style="flex-grow: 1;">
        <cargo-ag-grid
          config-module="250721"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="250722"
          :total="pageInfo.total"
          :page.sync="pageInfo.pageNum"
          :limit.sync="pageInfo.pageSize"
          @pagination="searchHandle"
        />
      </div>
    </div>

    <!--    新增 编辑-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="addDialog.visible"
      :close-on-click-modal="false"
      :title="addDialog.title"
      width="440px"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px">
        <div class="filters">
          <el-form label-width="80px" label-position="left">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('CargoMsg.Cargo_ScenarioName')">
                <el-input v-model="addDialog.form.taskName" no="taskName" style="width: 300px" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_TaskScenario')">
                <el-select v-model="addDialog.form.taskScenario" style="width: 300px">
                  <el-option
                    v-for="(item,index) in SystemConstants.TASK_SCENARIO_LIST"
                    :key="index"
                    :label="language?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-if="addDialog.form.taskScenario !== SystemConstants.TASK_SCENARIO_2.code" :label="$t('CargoMsg.Cargo_DataType')">
                <el-select v-model="addDialog.form.dataType" style="width: 300px">
                  <el-option
                    v-for="(item,index) in SystemConstants.DATA_TYPE_LIST"
                    :key="index"
                    :label="language?item.chineseName:item.englishName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input v-model="addDialog.form.remarks" no="remarks" type="textarea" :rows="3" style="width:300px" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="onNext">{{ $t('CargoMsg.Cargo_Next') }}</el-button>
        <el-button @click="onCancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!--    详情页面-->
    <auto-config-detail
      v-show="addDialog.view === 'detail'"
      ref="autoConfigDetail"
      @refresh="searchHandle"
    />

    <task-log-dialog
      v-if="logDialog.visible"
      ref="taskLogDialog"
      :visible.sync="logDialog.visible"
      :form="logDialog.form"
      @close="logDialog.visible= false"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage } from '@/utils/commonUtil'
import {
  checkTaskNameFunc,
  copyConfigFunc,
  deleteAutoConfigFunc,
  manualRunFunc, pushShippingExchangeFunc,
  executeAutomationPushMls,
  queryFunc, executePushThirdPartyDataTask
} from '@/api/sysAutoConfig/sysAutoConfig'
import AutoConfigDetail from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/autoConfigDetail.vue'
import { AutomationConfig } from '@/class/model/sys/AutomationConfig'
import TaskLogDialog from '@/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/component/taskLogDialog.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { DATA_TYPE_2 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TaskScenario',
  components: {
    TaskLogDialog,
    AutoConfigDetail,
    cargoAdvanceSelect
  },
  data() {
    return {
      selectedRow: null,
      documentManage: new DocumentManage(),
      SystemConstants,
      addDialog: {
        visible: false,
        title: '',
        action: 'add',
        view: 'list',
        form: new AutomationConfig().fillDefaultValue().getData()
      },
      logDialog: {
        visible: false,
        form: new AutomationConfig().fillDefaultValue().getData()
      },
      autoConfigDialog: {
        visible: false
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TaskName'),
          field: 'taskName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaskScenario'),
          field: 'taskScenario',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.TASK_SCENARIO_LIST)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_RemarksInfo'),
          field: 'remarks',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'modifiedBy',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateTime'),
          field: 'dateModified',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AutoExecute'),
          field: 'executionStatus',
          width: 200,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return Number(params.value) === 1 ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'executionStatus',
          width: 200,
          cellRenderer: params => {
            const onOperation = this.documentManage.getPath('onOperation')
            return `<div onclick="${onOperation}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_Edit')}</div>`
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Execute'),
          field: 'executionStatus',
          width: 200,
          cellRenderer: params => {
            const onManualRun = this.documentManage.getPath('onManualRun')
            return `<div onclick="${onManualRun}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ManualRun')}</div>`
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Log'),
          field: 'executionStatus',
          width: 200,
          cellRenderer: params => {
            const onLog = this.documentManage.getPath('onLog')
            return `<div onclick="${onLog}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ExecutionLog')}</div>`
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => { this.selectedRow = event.data }
      },
      pageInfo: {
        jobNo: '',
        total: 0,
        pageNum: 1,
        pageSize: 20
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    }
  },
  mounted() {

  },
  beforeMount() {
    const context = this
    this.documentManage.set('onManualRun', function(value) {
      context.onManualRun(value)
    })
    this.documentManage.set('onOperation', function(value) {
      context.onOperation(value)
    })
    this.documentManage.set('onLog', function(value) {
      context.onLog(value)
    })
  },
  async created() {
    this.searchHandle()
  },
  methods: {
    async init() {},
    searchHandle() {
      this.addDialog.view = 'list'
      queryFunc(this.pageInfo).then(res => {
        this.pageInfo.total = Number(res.data.total)
        this.pageInfo.pageNum = res.data.pageNum
        this.pageInfo.pageSize = res.data.pageSize
        this.rowData = res.data.list
      })
    },
    showDataType(item) {
      if (this.addDialog.form.taskScenario === SystemConstants.TASK_SCENARIO_3.code || this.addDialog.form.taskScenario === SystemConstants.TASK_SCENARIO_4.code) {
        return item.code === SystemConstants.DATA_TYPE_2.code
      } else if (this.addDialog.form.taskScenario === SystemConstants.TASK_SCENARIO_5.code) {
        return item.code === SystemConstants.DATA_TYPE_1.code
      }
      return true
    },
    clearFrom() {
      this.addDialog.form = new AutomationConfig().fillDefaultValue().getData()
      this.addDialog.form.taskScenario = 'invoicing'
      this.addDialog.form.dataType = 1
    },
    // 新增
    btnAdd() {
      this.clearFrom()
      this.addDialog.title = this.$t('CargoMsg.Cargo_New') + this.$t('CargoMsg.Cargo_TaskScenario')
      this.addDialog.action = 'add'
      this.addDialog.visible = true
    },
    btnCopy() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length !== 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      const loading = getLoading4Cxt(this)
      copyConfigFunc({ uuid: items[0].uuid }).then(res => {
        this.searchHandle()
      }).finally(res => {
        loading.close()
      })
    },
    btnRemoveHandler() {
      const items = this.gridOptions.api.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      for (const data of items) {
        if (data.executionStatus === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaskScenarioAutoExecuteCannotDelete'))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmDeleteTaskScenario'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading4Cxt(this)
        const keys = Array.from(items, p => p.uuid)
        deleteAutoConfigFunc({ keys: keys }).then(res => {
          this.searchHandle()
        }).finally(res => {
          loading.close()
        })
      })
    },
    // 编辑
    async onOperation(uuid) {
      const data = this.rowData.filter(row => row.uuid === uuid)
      if (data && data.length > 0) {
        this.addDialog.form = data[0]
        this.addDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_TaskScenario')
        this.addDialog.action = 'edit'
        this.addDialog.visible = true
      }
    },
    async onManualRun(uuid) {
      const data = this.rowData.filter(row => row.uuid === uuid)
      if (data && data.length > 0) {
        await this.$confirm(this.$t('CargoMsg.Cargo_ConfirmBatchOperation'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('SeaExport.Yes'),
          cancelButtonText: this.$t('SeaExport.No'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          if (data[0].taskScenario === SystemConstants.TASK_SCENARIO_2.code) {
            pushShippingExchangeFunc({ uuid: uuid }).then(res => {
              this.$message.success(this.$t('CargoMsg.Cargo_AsyncExecutingCheckLogLater'))
            })
          } else if (data[0].taskScenario === SystemConstants.TASK_SCENARIO_3.code || data[0].taskScenario === SystemConstants.TASK_SCENARIO_4.code || data[0].taskScenario === SystemConstants.TASK_SCENARIO_5.code) {
            executeAutomationPushMls({ uuid: uuid }).then(res => {
              this.$message.success(this.$t('CargoMsg.Cargo_AsyncExecutingCheckLogLater'))
            })
          } else if (data[0].taskScenario === SystemConstants.TASK_SCENARIO_6.code) {
            executePushThirdPartyDataTask({ uuid: uuid }).then(res => {
              this.$message.success(this.$t('CargoMsg.Cargo_AsyncExecutingCheckLogLater'))
            })
          } else {
            manualRunFunc({ uuid: uuid }).then(res => {
              this.$message.success(this.$t('CargoMsg.Cargo_AsyncExecutingCheckLogLater'))
            })
          }
        })
      }
    },
    // 查看日志
    async onLog(uuid) {
      const data = this.rowData.filter(row => row.uuid === uuid)
      if (data && data.length > 0) {
        this.logDialog.form = data[0]
        this.logDialog.visible = true
      }
    },
    // 下一步
    onNext() {
      if (!this.addDialog.form.taskName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_TaskNameCannotBeEmpty'))
        return
      }
      const params = {
        anyStr: this.addDialog.form.taskName
      }
      if (this.addDialog.action === 'edit') {
        params.anyStr1 = this.addDialog.form.uuid
      }
      checkTaskNameFunc(params).then(res => {
        if (res.data) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaskNameAlreadyExists', [this.addDialog.form.taskName]))
        } else {
          this.nextHandler()
        }
      })
    },
    nextHandler() {
      this.addDialog.visible = false
      this.addDialog.view = 'detail'
      this.$refs.autoConfigDetail.onShow(this.addDialog.action, this.addDialog.form)
    },
    // 取消
    onCancel() {
      this.clearFrom()
      this.addDialog.visible = false
    }
  }
}
</script>
